
export default {

	29: 'для щенков миниатюрных пород',
	30: 'для щенков мелких пород',
	31: 'для щенков средних пород',
	32: 'для щенков крупных и очень крупных пород',
	33: 'для щенков всех пород с чувствительной пищеварительной системой',
	51: 'для щенков всех пород',

	34: 'для взрослых собак миниатюрных пород',
	35: 'для взрослых собак мелких пород',
	36: 'для взрослых собак средних пород',
	37: 'для взрослых собак крупных и очень крупных пород',
	38: 'для взрослых собак всех пород<br>с чувствительными пищеварительной<br>системой и кожей',
	39: 'для взрослых собак крупных<br>и очень крупных пород с чувствительной<br>пищеварительной системой',

	52: 'для взрослых собак всех пород',
	53: 'для взрослых собак всех пород',
	54: 'для взрослых собак всех пород',

	44: 'для пожилых собак крупных и очень крупных пород',
	45: 'для пожилых собак всех пород<br>с чувствительными пищеварением и кожей',

}



// WEBPACK FOOTER //
// ./src/data/food.js